import styled, { useTheme } from 'styled-components';
import Row from '../core/components/box/row';
import { device, TabletAndBelow, useMedia } from '../core/designSystem/device';
import { LXh3 } from '../core/texts/lxText';
import SizedBox from '../core/components/box/sizedBox';
import mainImage from './assets/main.png';
import leftImage from './assets/left.png';
import rightImage from './assets/right.png';
import { ReactComponent as Text } from './assets/text.svg';
import Column from '../core/components/box/column';
import MobileDrawer from './components/mobileDrawer';
import { useState } from 'react';
import BannerNav from './components/bannerNav';

const BackGroundColor = styled.div`
  width: 100%;
  height: 500px;
  background-color: ${(props) => props.theme.colors.mainBg};
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;

  @media ${device.desktop} {
    height: 600px;
  }
`;

const Image = styled.img<{ delay?: number }>`
  position: relative;
  height: 100%;
  animation: opacity 15s ease-in-out infinite;
  animation-delay: ${(props) => props.delay}s;
`;

const ImageContainer = styled.div`
  width: 100%;
  height: 306px;
  display: flex;
  align-items: center;
  position: relative;
  justify-content: center;

  @media ${device.desktop} {
    transform: translate(-195px);
    animation: slide 15s ease-in-out infinite;
    animation-delay: 4s;
    height: 384px;
  }
`;

const Box = styled.div<{ width?: string; height?: string }>`
  flex-grow: 0;
  width: calc(50% - 390px);
  flex-basis: calc(50% - 390px);
  height: ${(props) => props.height};
  min-width: calc(50% - 390px);
  min-height: ${(props) => props.height};
`;

const MainTextContainer = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 310px;
  top: 116px;
  margin: auto;
  @media ${device.desktop} {
    width: 520px;
    top: 136px;
  }
`;

interface BannerProps {}
const Banner = (props: BannerProps) => {
  const theme = useTheme();
  const { isTabletAndBelow } = useMedia();
  const [drawerOpen, setOpen] = useState(false);
  const closeDrawer = () => {
    setOpen(false);
  };
  const openDrawer = () => {
    setOpen(true);
  };

  const BackGroundImages = () => (
    <ImageContainer>
      {isTabletAndBelow ? (
        <Image src={mainImage} />
      ) : (
        <Row overflow="initial" width="100%" alignItems="center">
          <Image delay={-6} src={leftImage} />
          <Box />
          <Image delay={-1} src={mainImage} />
          <Box />
          <Image delay={-11} src={rightImage} />
          <Box />
          <Image delay={-6} src={leftImage} />
          <Box />
          <Image delay={-1} src={mainImage} />
          <Box />
          <Image delay={-11} src={rightImage} />
        </Row>
      )}
    </ImageContainer>
  );

  const MainText = () => (
    <MainTextContainer>
      <SizedBox height={isTabletAndBelow ? 42 : 123} />
      <Text />
      <SizedBox height={isTabletAndBelow ? 138 : 54} />
      <LXh3
        alignSelf="flex-end"
        height="46px"
        textAlign="right"
        fontWeight={400}
        whiteSpace="pre-wrap"
        color={theme.colors.white}
      >
        {`${theme.intro.worldClass}\n${theme.intro.healthcarePartner}`}
      </LXh3>
    </MainTextContainer>
  );

  return (
    <Column width="100%" alignItems="center">
      <BackGroundColor>
        <BannerNav onClickHambergurMenu={openDrawer} />
        <SizedBox height={isTabletAndBelow ? 65 : 48} />
        <BackGroundImages />
        <MainText />
        <TabletAndBelow>
          <MobileDrawer onClose={closeDrawer} open={drawerOpen} />
        </TabletAndBelow>
      </BackGroundColor>
    </Column>
  );
};

export default Banner;
